import { useEffect, useRef, useState } from 'react';

/**
 * The old SearchInput's timing for the list pages (revamp PR 7a): the field shows every keystroke, and `onSearch`
 * gets the text 300 ms after the last one.
 */
export function useDebouncedSearch(initial: string, onSearch: (value: string) => void) {
  const [value, setValue] = useState(initial);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(
    () => () => {
      if (timer.current) clearTimeout(timer.current);
    },
    []
  );
  const onChange = (next: string) => {
    setValue(next);
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => onSearch(next), 300);
  };
  return [value, onChange] as const;
}
